import { createEffect, createSignal } from "solid-js"
import { type Scene } from "three"
import type { Nullable } from "vite-node"
import { onCleanupRemoveAndDispose } from "../../../../../rx/cleanup/onCleanupRemoveAndDispose"
import useGridWidthHeight from "../../../../../rx/memo/useGridWidthHeight"
import { useNodeNeighborBaseFloorElevationReactiveMap } from "../../../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap"
import isIdListSame from "../../../../../rx/signal/equals/isIdListSame"
import type { Engine } from "../../../../core/engine/Engine.type"
import { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import type { Entity } from "../../../../core/entity/index"
import { next } from "../../../../core/rng/index"
import tmpRngWith from "../../../../core/rng/tmpRngWith"
import createBoulderInstancedMeshV1Group from "./createBoulderInstancedMeshV1Group"

function isEntityWithBoulder(ent: Entity) {
  const { id, etype_id } = ent
  if (etype_id === EntityTypeId.Desert) {
    return next(tmpRngWith(id)) < 0.3
  }
  if (etype_id === EntityTypeId.Forest) {
    return next(tmpRngWith(id)) < 0.3
  }
  if (etype_id === EntityTypeId.Jungle) {
    return next(tmpRngWith(id)) < 0.3
  }
  if (etype_id === EntityTypeId.Plain) {
    return next(tmpRngWith(id)) < 0.1
  }
  if (etype_id === EntityTypeId.Mountain) {
    return false
  }
  if (etype_id === EntityTypeId.River) {
    return next(tmpRngWith(id)) < 0.1
  }
  if (etype_id === EntityTypeId.Sea) {
    return next(tmpRngWith(id)) < 0.2
  }
  if (etype_id === EntityTypeId.Shoal) {
    return next(tmpRngWith(id)) < 0.3
  }
  if (etype_id === EntityTypeId.Snow) {
    return next(tmpRngWith(id)) < 0.2
  }
  return false
}

export default function createBoulderInstancedMeshV1Effect(
  engine: Engine,
  scene: Scene,
) {
  const neighborBaseElevationReactiveMap = useNodeNeighborBaseFloorElevationReactiveMap(engine)
  const getGridSize = useGridWidthHeight(engine)

  const [getEnts, setEnts] = createSignal<Array<Entity>>([], {
    equals: isIdListSame,
  })
  createEffect(() => {
    setEnts(engine.state.ents.filter(isEntityWithBoulder))
  })

  // createEffect(() => {
  //   console.log('createBoulderInstancedMeshV1Effect.getEnts', getEnts().length)
  // })

  let mesh: Nullable<ReturnType<typeof createBoulderInstancedMeshV1Group>> = null
  createEffect(() => {
    // if empty, don't bother
    if (neighborBaseElevationReactiveMap.size > 0) {
      // const oldGroup = group
      const ents = getEnts()

      mesh = createBoulderInstancedMeshV1Group(
        neighborBaseElevationReactiveMap,
        ents, getGridSize().width)
      scene.add(mesh)

      onCleanupRemoveAndDispose(mesh)
    }
  })
}
